import { render } from "./CareerReadinessPurchase.vue?vue&type=template&id=ca3d81a4"
import script from "./CareerReadinessPurchase.vue?vue&type=script&lang=js"
export * from "./CareerReadinessPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__